/**
 * generates the props needed to supply HeaderSearch component within search view
 */

// eslint-disable-next-line import/no-unresolved
import { computed } from '@vue/composition-api';
import StateProviderSetup from 'mixins/composition/search/StateProvider';
import getNumberFormat from 'mixins/composition/NumberFormat';
import config from 'config/appConfig';

export default ({ app, store }) => {
  const { formatNumber } = getNumberFormat({
    root: {
      $store: store,
    },
  });

  const {
    isSeoPage, isSeaPage, seoContent, totalObjects, locationTitle,
  } = StateProviderSetup({ app, store });
  // EDVUE-3417 rename russia
  const mergedterm = store.getters.getMergedTerms;
  if (mergedterm?.country === 'ru') {
    locationTitle.value.title = app.$t('common:headerSearch.peace');
  }

  const headerSearchSubtitle = computed(() => {
    // EDVUE-3417 rename russia
    const mergedterms = store.getters.getMergedTerms;
    if (mergedterms?.country === 'ru') {
      locationTitle.value.title = app.$t('common:headerSearch.peace');
    }
    if (isSeoPage.value) {
      if (seoContent.value.title !== '') return seoContent.value.title;
      return app.$t('common:headerSearch.subtitle', { titlePrepo: locationTitle.value.titlePrepo });
    }
    if (isSeaPage.value && totalObjects.value > 1) {
      return app.$t('common:headerSearch.subtitleWithCount', {
        count: formatNumber(totalObjects.value),
        titlePrepo: locationTitle.value.titlePrepo,
      });
    }

    return app.$t('common:headerSearch.subtitle', { titlePrepo: locationTitle.value.titlePrepo });
  });

  const showMultiHeadline = computed(() => !(['search-offer', 'search-ski'].includes(store.state.route.name)));
  const headerSearchTitleHtml = computed(() => {
    if (config.search.showClaim === false) {
      return '';
    }
    // EDVUE-3417 rename russia
    const mergedterms = store.getters.getMergedTerms;
    if (mergedterms?.country === 'ru') {
      locationTitle.value.title = app.$t('common:headerSearch.peace');
    }
    return app.$t('common:headerSearch.title', {
      title: (locationTitle.value.title === app.$t('common:headerSearch.locationTitleAll')) ? app.$t('common:keyData.objectType.house') : locationTitle.value.title,
    });
  });

  return { headerSearchSubtitle, showMultiHeadline, headerSearchTitleHtml };
};
